import { render } from "./OutrasInformacoes.vue?vue&type=template&id=65f34cdf&scoped=true"
import script from "./OutrasInformacoes.vue?vue&type=script&lang=js"
export * from "./OutrasInformacoes.vue?vue&type=script&lang=js"

import "./OutrasInformacoes.vue?vue&type=style&index=0&id=65f34cdf&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-65f34cdf"]])

export default __exports__